// Packages
import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

// Components
import Form from "@components/mb-contact/form"
import ContactInfo from "@components/mb-contact/contact-info"
import Team from "@components/mb-contact/mb-team"
import SEO from "@components/global/seo"

// Data
import { bankerData } from "@components/global/layout-walled-mb"
const Header = styled.header`
  position: relative;
`

const Contact = props => {
 
  return (
    <>
      <Header>
        <Form
          mbEmail={
            props.bankerData.email === "teamjohnston@atlanticbay.com"
              ? [
                  "kerryjohnston@atlanticbay.com",
                  "ryanjohnston@atlanticbay.com",
                ]
              : props.bankerData.formEmail
          }
          mbFullName={props.bankerData.fullName}
          bannerTitle={
            props.bankerData.aboutBanner
              ? props.bankerData.aboutBanner.title
              : "default"
          }
          bannerImage={
            props.bankerData.aboutBanner
              ? props.bankerData.aboutBanner.gatsbyImageData
              : props.data.Banner.childImageSharp.gatsbyImageData
          }
        />
      </Header>
      <ContactInfo {...props.bankerData} />
      {props.data.PersonnelPage.teammate && (
        <Team teammate={props.data.PersonnelPage.teammate} />
      )}
    </>
  )
}

// Meta tags
export const Head = props => {
  return (
    <SEO
      description={`Get in touch with ${bankerData.name} and begin your journey towards homeownership.`}
      title={`Contact ${bankerData.name} | Atlantic Bay Mortgage Group®`}
      ogImage={bankerData.ogImage && "https:" + bankerData.ogImage.file.url}
      slug={`${bankerData.slug}/contact`}
    />
  )
}

export default Contact

export const query = graphql`
  query ($slug: String!) {
    Banner: file(relativePath: { regex: "/mb-about/default-banner.jpg/" }) {
      childImageSharp {
        gatsbyImageData(width: 1440, quality: 100)
      }
    }
    PersonnelPage: contentfulPersonnelPage(slug: { eq: $slug }) {
      teammate {
        email
        nmls
        fullname
        phone
        title
        headshot {
          gatsbyImageData(width: 200, quality: 100)
        }
      }
    }
  }
`
